import { apiGet, apiPut } from './api';

export async function getPaymentGatewaySettings() {
  return apiGet<{ success: boolean; settings: Record<string, unknown> }>(
    '/api/v1/admin/payment-gateway/settings'
  );
}

export async function getPaymentGatewayPlans() {
  return apiGet<{ success: boolean; plans: Array<Record<string, unknown>> }>(
    '/api/v1/admin/payment-gateway/plans'
  );
}

export async function updatePaymentGateway(gateway: 'polar' | 'paypal', notes?: string) {
  return apiPut<{ success: boolean; message?: string }>('/api/v1/admin/payment-gateway/update', {
    gateway,
    notes: notes || undefined,
  });
}
